<<!-- kolpross -->
<template>
  <div class="fz-14 line-14">
    <div class="fz-18 mb-30 mt-10 line-18">抖音认证流程</div>
    <div class="flex-al p-step">
      <div class="step">1</div>
      <div class="fz-14">生成星罗好货【个人专属验证码】</div>
    </div>
    <el-row class="line-14">
      <el-col :span="24">
        <div class="fl mt-20 mb-30 ml-40">
          <el-tooltip placement="right" content="请将【个人专属验证码】编辑到抖音或快手【个人简介】最后面">
            <div class="b-ea4 c-fff mynumber flex-al default">
              <span class="fz-14">个人专属验证码</span>
              <span class="jiange">|</span>
              <span class="bold fz-14">{{authentication_code}}</span>
              <i class="el-icon-question ml-4"></i>
            </div>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">2</div>
          <div class="fz-14">
            将【个人专属验证码】输入要认证的
            <span class="c-ea4">抖音号签名最后方</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class=" mb-29 mt-20">
        <img src="../../assets/kolpross/douyin1.png" class='ml-40'>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">3</div>
          <div class="fz-14">
            在
            <span class="c-ea4">认证列表</span>里【添加认证】并填入
            <span class="c-ea4">抖音号、个人分享链接</span>（个人名片-复制链接）和
            <span class="c-ea4">微信号</span>并
            <el-button type="primary" @click='goKolpross'>添加认证</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class=" mt-10 mb-30">
        <img src="../../assets/kolpross/douyin2s.png" class="w-928 ml-40">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">4</div>
          <div class="fz-14">等待审核认证结果</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class=" mb-30 mt-3">
        <img src="../../assets/kolpross/douyin4s.png" class="w-928 ml-40">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">5</div>
          <div class="fz-14">提交抖音作业</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="mb-40 mt-20">
        <img src="../../assets/kolpross/douyin5s.png" class="w-928 ml-40 ">
      </el-col>
    </el-row>
    <el-row class="line-18 mb-30">
      <el-col :span="24" class="fz-18">快手认证流程</el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">1</div>
          <div class="fz-14">生成星罗好货【个人专属验证码】</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="line-14">
      <el-col :span="24">
        <div class="fl mt-20 mb-30 ml-40">
          <el-tooltip placement="right" content="请将【个人专属验证码】编辑到抖音或快手【个人简介】最后面">
            <div class="b-ea4 c-fff mynumber flex-al default">
              <span class="fz-14">个人专属验证码</span>
              <span class="jiange">|</span>
              <span class="bold fz-14">{{authentication_code}}</span>
              <i class="el-icon-question ml-4"></i>
            </div>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">2</div>
          <div class="fz-14">
            将【个人专属验证码】输入要认证的
            <span class="c-ea4">快手签名最后方</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="mt-20 mb-43">
        <img src="../../assets/kolpross/kuaishou2s.png" class="w-928 ml-40 ">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">3</div>
          <div class="fz-14">
            在
            <span class="c-ea4">认证列表</span>里【添加认证】并填入
            <span class="c-ea4">快手号、个人分享链接</span>（个人名片-复制链接）和
            <span class="c-ea4">微信号</span>并
            <el-button type="primary" @click='goKolpross'>添加认证</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class=" mt-10 mb-30">
        <img src="../../assets/kolpross/kuaishou3s.png" class="w-928 ml-40">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">4</div>
          <div class="fz-14">等待审核认证结果</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class=" mb-30 mt-3">
        <img src="../../assets/kolpross/kuaishou4s.png" class="w-928 ml-40">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="flex-al p-step">
          <div class="step">5</div>
          <div class="fz-14">提交快手作业</div>
        </div>
      </el-col>
    </el-row>
     <el-row>
      <el-col :span="24" class=" mb-40 mt-20">
        <img src="../../assets/kolpross/kuaishou5s.png" class="w-928 ml-40">
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "./tool.css";
export default {
  name: "kolpross",
  data() {
    return {
      authentication_code:'',
    };
  },
  components: {},
  created() {
    this.authentication_code = this.$http.getAuth(
      "user_info"
    ).authentication_code;
  },
  mounted() {},
  methods: {
    goKolpross(num){

        window.open('https://xl.linkstars.com/admin/#/my/heads?type=2')
      
    }
  }
};
</script>
<style  scoped>
.step {
  background: rgba(157, 168, 247, 0.74);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 25px;
  margin-right: 14px;
  -moz-box-shadow: 0px 1px 11px #6435E8;
  -webkit-box-shadow: 0px 1px 11px #6435E8;
  box-shadow: 0px 1px 11px #6435E8;
}

.p-step {
  padding-bottom: 20px;
  border-bottom: 1px solid #f5f5f5;
}
.mynumber {
  height: 24px;
  border-radius: 16px;
  line-height: 22px;
  padding: 0 6px;
}
.jiange {
  padding: 0 4px;
}
.w-928 {
  /* width:928px; */
}
</style>